import { useTranslation } from "react-i18next";
import useFetch from "../../../../../server/useFetch";
import { Col, Row } from "antd";
import { PageTitle } from "../../../../../styles/global/Pages.styled";
import { Text } from "../../../Atomics/Text";
import { Widget } from "../../../Atomics/Widget";
import { IconWrapper } from "@synergy/icons";
import { NoData } from "../../../Atomics/NoData";
import { useEffect, useState } from "react";

export const HomepageParkingCharts = () => {
    const { t } = useTranslation();

    const date = new Date()
    const [months] = useState([
        { label: t("January"), value: "jan" },
        { label: t("February"), value: "feb" },
        { label: t("March"), value: "mar" },
        { label: t("April"), value: "apr" },
        { label: t("May"), value: "may" },
        { label: t("June"), value: "jun" },
        { label: t("July"), value: "jul" },
        { label: t("August"), value: "aug" },
        { label: t("September"), value: "sep" },
        { label: t("October"), value: "oct" },
        { label: t("November"), value: "nov" },
        { label: t("December"), value: "dec" }
    ]);
    const [selectedMonth, setSelectedMonth] = useState(months[date.getMonth()].value);
    const currentYear = date.getFullYear();
    const [years] = useState(
        Array.from({ length: currentYear - 2024 + 1 }, (_, index) => ({
            label: (2024 + index).toString(),
            value: (2024 + index).toString(),
        }))
    );
    const [selectedYear, setSelectedYear] = useState(currentYear.toString());

    const { data: parkingData, refetch: refetchParkingData, isFetching: parkingDataIsFetching, remove: removeParkingData } = useFetch(
        `/nova_wallboards/getparkingdata`, "parkingData",
        { month: selectedMonth, year: selectedYear }, null, null, 'https://36lsp94v05.execute-api.eu-west-1.amazonaws.com/v3_0_01', 300000);

    useEffect(() => {
        refetchParkingData();
    }, [selectedMonth, selectedYear]);

    return (
        <Row gutter={[16, 16]}>
            <Col span={24} id="parking">
                <PageTitle>
                    <Text $fontColor="coolgray-12" $fontSize="text_md" $weight="medium" $marginRight="s03">{t("Parking")}</Text>
                </PageTitle>
            </Col>
            <Col span={6}>
                <Widget
                    data={{
                        background: "transparent",
                        title: t("title.Incidents by priority"),
                        icon: 'Clipboard',
                        border: null,
                        background: 'white',
                        height: '100%',
                        activeShadow: true,
                        margin: "0 0 10px 0",
                    }}
                >
                    {parkingData?.incidents ?
                        getByPriorityWidget(parkingData?.incidents, t)
                        : <NoData />}
                </Widget>
            </Col>
            <Col span={6}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Cumulative Number Of Entries In The Parking"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "bigNumberChart",
                                chartId: "bigNumberChartOne",
                                height: "111px",
                                isFetching: parkingDataIsFetching,
                                data: {
                                    number: parkingData?.numberOfUsesOfThePark,
                                    unit: "/semana atual",
                                    language: 'de-DE'
                                },
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={6}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Number Of Exits Of The Park"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "bigNumberChart",
                                chartId: "bigNumberChartOne",
                                height: "111px",
                                isFetching: parkingDataIsFetching,
                                data: {
                                    number: parkingData?.numberOfExitsOfThePark,
                                    unit: "/dia",
                                    language: 'de-DE'
                                },
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={6}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Number Of Entries In The Park"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "bigNumberChart",
                                chartId: "bigNumberChartOne",
                                height: "111px",
                                isFetching: parkingDataIsFetching,
                                data: {
                                    number: parkingData?.numberOfEntriesInThePark,
                                    unit: "/dia",
                                    language: 'de-DE'
                                },
                            },
                        ],
                    }}
                />
            </Col>
            {parkingData?.averageOcuption ?
                parkingData?.averageOcuption.map((item, index) => {
                    return (<Col span={6} key={index}>
                        <Widget
                            data={{
                                tooltip: t("title.Data from Sunday to Saturday"),
                                background: "white",
                                title: t(item.name),
                                icon: null,
                                activeShadow: true,
                                charts: [
                                    {
                                        chartType: "simpleDonutChartApex",
                                        chartId: "donutChartOne",
                                        height: "180px",
                                        data: {
                                            "series": item?.result.map((x) => { return { ...x, color: getDonutItemColor(x, item.name) } }),
                                            "categories": null,
                                            "tooltip": null,
                                            "markerSize": 3,
                                            "unit": "",
                                            "columnWidth": 20,
                                            "filename": "Gráfico exportado",
                                            "headerValue": "valores",
                                            "headerCategory": "categorias",
                                            "total": "",
                                            "disableTotal": true,
                                            "sideLegend": true,
                                            "dataLabelsOffset": 30,
                                            // disableDataLabels: true,
                                            showDataLabelsWithoutPercentage: true,
                                            "customScale": 0.9,
                                            centerVerticalLegend: true,
                                            disableToolbar: true
                                        },
                                    },
                                ],
                            }}
                        />
                    </Col>)
                }) : null}
            <Col span={12}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Number Of Entries In Campus"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "columnsChartApex",
                                height: "200px",
                                isFetching: parkingDataIsFetching,
                                data: parkingData?.occupationByWeekDay
                                    ? getNumberOfEntriesInCampus(parkingData?.occupationByWeekDay)
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={12}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Weekly Cumulative Number Of Entries Per Park"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "columnsChartApex",
                                height: "200px",
                                isFetching: parkingDataIsFetching,
                                data: parkingData?.occupationByCategoryInWeek
                                    ? getCumulativeNumberOfEntriesInCampus(parkingData?.occupationByCategoryInWeek)
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={24}>
                <Widget
                    data={{
                        background: "white",
                        title: t("title.Number Of Entries In Campus By Month"),
                        icon: null,
                        activeShadow: true,
                        dropdowns: [
                            {
                                data: months,
                                value: selectedMonth,
                                functionChange: (value) => {
                                    setSelectedMonth(value)
                                },
                                width: "150px",
                            },
                            {
                                data: years,
                                value: selectedYear,
                                functionChange: (value) => {
                                    setSelectedYear(value)
                                },
                                width: "100px",
                            }
                        ],
                        charts: [
                            {
                                chartType: "columnsChartApex",
                                height: "200px",
                                isFetching: parkingDataIsFetching,
                                data: parkingData?.occupationByMonth
                                    ? getNumberOfEntriesInCampus(parkingData?.occupationByMonth)
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
        </Row>
    )
};

const getByPriorityWidget = (data, t) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}>


                {[{ label: 'Red', count: data["red"] ?? 0 },
                { label: 'Orange', count: data["orange"] ?? 0 },
                { label: 'Yellow', count: data["yellow"] ?? 0 }].map((status, index) => (
                    <div key={index} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '30%', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <IconWrapper $bgColor={status.label} $bgsize="5px" />
                            <h1 style={{ margin: '0', marginLeft: '5px' }}>{status.count}</h1>
                        </div>
                        {/* <span>{t(status.label)}</span> */}
                    </div>
                ))}
            </div>
        </div>
    );
};

const getNumberOfEntriesInCampus = (data) => {
    const series = data.map((item) => {
        return {
            x: item.name,
            y: item.uv,
        }
    });

    return {
        series: [
            {
                name: '',
                data: series,
            }
        ],
        categories: [],
        tooltip: null,
        unit: "",
        columnWidth: 20,
        xAxisLabel: null,
        yAxisLabel: "",
        color: ['yellow'],
        tickAmount: 12,
        showTooltipTitle: true,
        showLegend: false,
        // hideToolbar: true,
    };
};

const getCumulativeNumberOfEntriesInCampus = (data) => {
    const series = data.map((item) => {
        return {
            x: item.name,
            y: item.uv,
        }
    });

    return {
        series: [
            {
                name: '',
                data: series,
            }
        ],
        categories: [],
        tooltip: null,
        unit: "",
        columnWidth: 20,
        xAxisLabel: null,
        yAxisLabel: "",
        color: ['yellow'],
        tickAmount: 12,
        showTooltipTitle: true,
        showLegend: false,
        // hideToolbar: true,
    }
};

const getDonutItemColor = (result, name) => {
    if (result.name === "Ocupado" && name === 'P. Total') {
        return '#484848';
    } else if (result.name === "Livre" && name === 'P. Total') {
        return '#a1a1a1';
    } else if (result.name === "Ocupado" && name === 'P. Externo') {
        return '#026364';
    } else if (result.name === "Livre" && name === 'P. Externo') {
        return '#498d8f';
    } else if (result.name === "Ocupado" && name === 'P. Interior -1') {
        return '#84c437';
    } else if (result.name === "Livre" && name === 'P. Interior -1') {
        return '#b6d98c';
    } else if (result.name === "Ocupado" && name === 'P. Interior -2') {
        return '#ea813d';
    } else if (result.name === "Livre" && name === 'P. Interior -2') {
        return '#edb693';
    } else {
        return '#484848'; // Default color if no match
    }
}